<template>
  <form>
    <v-menu bottom left offset-y v-if="postedCommentUser">
      <v-btn
        slot="activator"
        small
        icon
        class="grey lighten-3"
        style="margin:6px 4px;"
      >
        <v-icon small>fas fa-ellipsis-h</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile v-if="postedCommentUser" @click="callDeleteComment">
          <v-list-tile-title> {{ lang.comment_delete }} </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </form>
</template>

<script>
export default {
  name: "vc-share-comment-menu-button",
  props: {
    commentId: {
      type: Number,
      default: 0
    },
    postedCommentUser: {
      type: Boolean,
      default: false
    },
    lang: {
      type: Object,
      default: () => {
        return {
          comment_report_title: "問題のあるコメントです",
          comment_report_description:
            "コメントに問題がある場合はこちらからご報告ください（3000文字以内）。",
          select_comment_report_category: "問題点を選択",
          comment_report_category_in_appropriate: "掲載に不適切である",
          comment_report_category_uncomfortable:
            "不快に感じる、モラルに反している",
          comment_report_category_copyright: "著作権などの権利を侵害している",
          comment_report_category_illegal: "法律や規約に違反している",
          comment_report_category_etc: "その他",
          report: "通報する",
          submit: "送信",
          sent: "送信しました。",
          error_report_failed: "通報に失敗しました。",
          comment_delete: "コメントを削除",
          confirm: "このコメントを削除します。よろしいですか？",
          comment_deleted: "コメントを削除しました。",
          error_delete_failed: "削除に失敗しました。",
          login_necessary: "CLIPアカウントでログインしてください",
          login_here: "ログインはこちら",
          report_contents: "通報内容",
          problem: "問題点",
          close: "閉じる"
        };
      }
    },
    clipIsLoggedIn: {
      type: Boolean,
      default: false
    },
    clipLoginUrl: {
      type: String,
      default: ""
    },
    localeCode: {
      type: String,
      default: ""
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "",
          max: {
            string: ""
          }
        };
      }
    },
    deleteComment: {
      type: Function,
      default: () => {}
    },
    reportComment: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      isLoading: false
    };
  },
  mounted: function() {
    this.$validator.localize(this.localeCode, this.dictionary);
  },
  methods: {
    callDeleteComment: function() {
      if (!confirm(this.lang.confirm)) {
        return;
      }

      let thisObject = this;

      this.deleteComment(this.commentId).then(function(value) {
        if (value === 0) {
          alert(thisObject.lang.comment_deleted);
        }
      });
    },
    moveSpecifiedPage: function(url) {
      location.href = url;
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}
</style>
